import { axiosInstance } from "helpers";

export async function getAllEmailTemplates() {
  return await axiosInstance
    .get("email-templates", {
      params: {
        api_key: localStorage.getItem("apikey"),
      },
    })
    .then((response) => response.data);
}

export async function updateEmailTemplate({
  id,
  email_subject,
  email_body,
  email_title,
}) {
  return await axiosInstance
    .post("email-templates/update", {
      id,
      api_key: localStorage.getItem("apikey"),
      email_subject,
      email_body,
      email_title,
    })
    .then((response) => response.data);
}
